module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "place-order"
  }, [(!_vm.isShowXiniyuan) ? _c('Card', [_c('ContainerBalanceChart', {
    ref: "dayChart",
    attrs: {
      "default-port-ids": _vm.defaultPortIds,
      "port-option-list": _vm.portOptionList
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isShowXiniyuan) ? _c('Card', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('ContainerBalanceMonth', {
    ref: "monthChart",
    attrs: {
      "default-port-ids": _vm.defaultPortIds,
      "port-option-list": _vm.portOptionList
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isShowXiniyuan) ? _c('Card', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 12
    }
  }, [_c('FeeConfirmChart')], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isShowXiniyuan) ? _c('Card', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 12
    }
  }, [_c('MonthlyBillChart')], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "9"
    }
  }, [_c('Card', {
    staticClass: "status-card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', [_c('span', {
    staticClass: "rectangle"
  }), _vm._v(" 可用额度")]), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "transfer": ""
    }
  }, [_c('i', {
    staticClass: "iconfont iconquestion"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticStyle: {
      "min-width": "300px",
      "font-size": "12px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cardData.availableCreditShow)
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-content-item"
  }, _vm._l((_vm.cardData.companyCredits), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "big-font",
      class: [
        item.availableAmount <= 0 ?
        'text-red' :
        'text-green' ]
    }, [_vm._v(_vm._s(_vm.spliceCurrencySymbolAndCost(item.currency, item.availableAmount)))])
  }), 0)])])], 1), _vm._v(" "), (_vm.cardData.overDurBillInfoStatistics && _vm.cardData.overDurBillInfoStatistics.overDurBillInfoList.length) ? _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Card', {
    staticClass: "status-card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', [_c('span', {
    staticClass: "rectangle"
  }), _vm._v(" 逾期账款")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-content-item"
  }, [_vm._v("\n              逾期账单周期: " + _vm._s(_vm.cardData.overDurBillInfoStatistics.toDate) + ",\n                   共计逾期未核销金额\n              "), _vm._l((_vm.cardData.overDurBillInfoStatistics.overDurBillInfoList), function(item) {
    return _c('p', {
      staticClass: "text-red"
    }, [_vm._v(_vm._s(_vm.spliceCurrencySymbolAndCost(item.currency, item.amount)))])
  })], 2)])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.$route.name === 'place-order-index' && (_vm.isShowBtn || _vm.done)) ? [(!_vm.isShowXiniyuan) ? _c('Button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleRouterGo('main-query-charge_index')
      }
    }
  }, [_vm._v("新门点下单")]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticStyle: {
      "color": "#ff9100",
      "margin-right": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.handleRouterGo('create-history-order')
      }
    }
  }, [_vm._v("老门点下单")]), _vm._v(" "), (_vm.showUploadDocumentTemplate) ? _c('Button', {
    staticStyle: {
      "color": "#ff9100"
    },
    on: {
      "click": function($event) {
        _vm.uploadModal.show = true
      }
    }
  }, [_vm._v("托书模板上传")]) : _vm._e()] : (_vm.$route.name === 'place-order-pre' && (_vm.isShowBtn || _vm.done)) ? [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleRouterGo(_vm.orderPath)
      }
    }
  }, [_vm._v("继续下单")])] : _vm._e()], 2), _vm._v(" "), _c('BillCheckModal', {
    ref: "billCheckModal",
    on: {
      "place-order": _vm.onPlaceOrder
    }
  }), _vm._v(" "), _c('Modal', {
    staticClass: "upload-modal",
    attrs: {
      "title": "上传托书",
      "mask-closable": false
    },
    model: {
      value: (_vm.uploadModal.show),
      callback: function($$v) {
        _vm.$set(_vm.uploadModal, "show", $$v)
      },
      expression: "uploadModal.show"
    }
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "multiple": false,
      "headers": _vm.headersObj,
      "max-size": 10240,
      "before-upload": _vm.handleUpload,
      "type": "drag",
      "action": "/harbour-server/duckBill/uploadDocumentTemplate/createOrder"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击或将文件拖拽到这里上传")]), _vm._v(" "), _c('p', [_vm._v("支持扩展名：.txt")]), _vm._v(" "), _c('p', [_vm._v("文件最大不能超过 10M")])], 1)]), _vm._v(" "), (_vm.uploadTxt.name) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.uploadTxt.name) + "\n          "), _c('Icon', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "close-round"
    },
    on: {
      "click": function($event) {
        _vm.uploadTxt = {
          name: null
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.uploadModal.show = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确认")])], 1)], 1), _vm._v(" "), _c('remind', {
    ref: "remind",
    on: {
      "hideRemind": _vm.hideRemind
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-9e773f78", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e773f78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/place-order/place-order.vue
// module id = 1371
// module chunks = 61